import React, { useEffect, useState } from "react";
import { API_URL } from "./config";
import { useNavigate } from "react-router-dom";
const DashboardContent = () => {
    useEffect(() => {
    document.title = "Dashboard | Oriflamme IT Solutions";
  }, []);
  
  const [quotationCount, setquotationCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
 useEffect(() => {
  const fetchQuotations = async () => {
    try {
      const response = await fetch(`${API_URL}/api/quotation`, {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      
      if (response.status === 401) {
        navigate("/login");
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch quotations");
      }

      const data = await response.json();
      console.log("Quotation API FULL:", data);

      let count = 0;

      if (Array.isArray(data)) {
        count = data.length;
      } else if (Array.isArray(data.data)) {
        count = data.data.length;
      } else if (Array.isArray(data.data?.data)) {
        count = data.data.data.length;
      }

      setquotationCount(count);
    } catch (error) {
      console.error("Quotation Error:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchQuotations();
}, [navigate]);

  return (
    <div className="container pt-3">
      <h2 className="mb-4 text-left">📊 Admin Dashboard</h2>

      <div className="row">
        <div className="col-md-4 mb-3">
          <div className="card text-white bg-primary shadow">
            <div className="card-body">
              <h5 className="card-title">Total Quotation</h5>

              {loading ? (
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <p className="card-text display-6 fw-bold">{quotationCount}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
